import { actionTypePrefix } from './constants';
export var ACTION_TYPE_INITIALIZE = actionTypePrefix + "/INITIALIZE";
//# sourceMappingURL=actionTypes.js.map